<template>

  <li v-if="link.sublinks.length == 0 && link.type != 'item item-divider'" class="nav-item  toolbar-link"
    @click="openSubLinkOrRedirect(link)" style="width: 200px;position:relative">
    <a class="nav-link active" aria-current="page" data-bs-dismiss="offcanvas" style="min-width:300px;"> <i
        class="canvas-item-icon " :class="link.icon_style"></i> {{ link.title[currentLanguage] }} </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary" style="top:20px">
      {{ unreadNews }}
    </span>
  </li>

  <li v-if="link.sublinks.length > 0 && link.type != 'item item-divider toolbar-divider'" class=" ">
    <a class="nav-link dropdown-toggle " href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown"
      aria-expanded="false" style="margin-left:20px;">
      <i class="canvas-item-icon " :class="link.icon_style"></i>


      <div v-if="open != link" @click="open = link"
        style="display:inline-block; width:210px; line-height:1rem;  white-space: normal; margin-left: 5px"> {{
          link.title[currentLanguage] }}</div>
      <small v-if="open != link && link.sublinks && link.sublinks.length > 0"> <font-awesome-icon
          :icon="['fas', 'chevron-down']" /> </small>

      <div v-if="open == link" @click="open = null"
        style="display:inline-block; width:210px; line-height:1rem;  white-space: normal;  margin-left: 5px"> {{
          link.title[currentLanguage] }} </div>


      <small v-if="open == link && link.sublinks && link.sublinks.length > 0"> <font-awesome-icon
          :icon="['fas', 'chevron-up']" /> </small>



    </a>



    <div style="box-shadow: none !important" class="dropdown-menu toolbar-submenu "
      aria-labelledby="navbarDropdownMenuLink">
      <ul>
        <template v-for="sublink in link.sublinks" :key="sublink.id">
          <a @click="openSubLinkOrRedirect(sublink)" style="margin-bottom:10px; white-space: normal;max-width: 250px;"
            class="dropdown-item" data-bs-dismiss="offcanvas"> <i class="canvas-item-icon "
              :class="sublink.icon_style"></i>
            {{ sublink.title[currentLanguage] }} </a>
        </template>
      </ul>
    </div>
  </li>

  <li v-if="link.type == 'item item-divider'" class="menu-divider mb-1 " style="line-height: 1rem">
    <b> {{ link.title[currentLanguage] }} </b>
  </li>

</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { addIcons } from "ionicons";
import {
  personCircleOutline,
  chatbubbleOutline,
  syncOutline,
  logOutOutline,
  logInOutline,
  searchCircleOutline,
  homeOutline,
  chevronBackOutline,
  chevronDownOutline,
  chevronUpOutline,
  cloudOfflineOutline,
  menuOutline
} from "ionicons/icons";

addIcons({
  "sync-outline": syncOutline,
  "person-circle-outline": personCircleOutline,
  "log-out-outline": logOutOutline,
  "log-in-outline": logInOutline,
  "chatbubble-outline": chatbubbleOutline,
  "search-circle-outline": searchCircleOutline,
  "home-outline": homeOutline,
  "chevron-back-outline": chevronBackOutline,
  "chevron-down-outline": chevronDownOutline,
  "chevron-up-outline": chevronUpOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  "menu-outline": menuOutline,
});
const config = require('@/config')
import router from '@/router';

export default {
  components: {},
  props: ['link'],
  data() {
    return {
      menulinks: [],
      menulinksTop: [],
      title: config.full_name,
      isConsultant: false,
      userConsultant: null,
      isDesktop: null,
      isIos: null,
      video_chat_enabled: false,
      confDate: config.conf_date,
      openSubBar: false,
      sublinks: null,
      time: null,
      appointmentsRole: null,
      searchterm: '',
      hideSearchBar: false,
      historyCount: 0,
      loginAlertOpen: false,
      onLine: navigator.onLine,
      showBackOnline: false,
      open: null,
    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user']),
    ...mapState('splashscreen', ['showSplashscreen']),
    ...mapState('personalDB', ['unreadNews']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'primaryColor', 'menuheader']),
  },
  methods: {
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions('sync', ['start']),
    ...mapActions("exhibitors", ["getAllExhibitors"]),
    ...mapActions('menulinks', ['isExternalLink']),
    ...mapActions('auth', ['GET_USERDATA']),
    ...mapMutations('splashscreen', ['setShowSplash']),
    ...mapActions("personalDB", ["connectPersonalDB", 'getItem', 'getItems', 'prepareFavoriteList', 'setTime', 'getUnreadNews']),
    ...mapMutations('personalDB', ['setUnreadNews']),
    ...mapActions('chat', ['getUnreadMessagesTotalCount']),
    ...mapActions('googleanalytics', ['trackWithLabel']),



    async openSubLinkOrRedirect(link) {
      this.trackWithLabel('menu_link:' + link.title.en)
      if (link.redirect == '/app/chat') {
        this.goToChat()
      } else if (link.id == 'c38899b3-39be-4296-9527-e7ab93f064cc') {
        this.showHelpAgain();
      } else {
        if (link.sublinks && link.sublinks.length > 0) {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
            router.push(link.redirect);
          }
        } else {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
            router.push(link.redirect);
          }
        }
      }

    },
  },

  mounted() {
  },
  beforeUnmount() {
  },

  watch: {}

};
</script>

<style>
.sublink-arrow {
  right: 0px;
}
</style>
